<template>
  <div class="layout-container">
    <el-tabs type="border-card">
      <el-tab-pane label="广告位列表">
        <div style="background: #ffffff;position:relative;">
          <div class="search-condition-con" :class="'show'">
            <div class="search-condition">
              <span class="label">广告位名称</span>
              <div class="input-condition">
                <el-input v-model="condition.name" placeholder="请输入广告位名称"></el-input>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">客户端</span>
              <div class="input-condition">
                <el-select v-model="condition.terminal_id" @change="getPages">
                  <el-option
                    v-for="(item, key) in terminals"
                    :value="item.id"
                    :label="item.name"
                    :key="key"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">页面名称</span>
              <div class="input-condition">
                <el-select v-model="condition.ad_page_id">
                  <el-option
                    v-for="(item, key) in pages"
                    :value="item.id"
                    :label="item.name"
                    :key="key"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="btn-condition">
            <el-button type="primary" @click="handleSearch()">查 询</el-button>
            <el-button @click="resetSearch()">清空条件</el-button>
          </div>
        </div>
        <div class="clearfix" style="margin-bottom: 5px;display:none;">
          <el-button-group class="floatR">
            <el-tooltip class="item" effect="dark" content="新增广告位" placement="top">
              <el-button
                icon="el-icon-plus"
                @click="handleAdd('新增')"
                v-permission="'operating.ad.ad-position.list.create'"
              ></el-button>
            </el-tooltip>
          </el-button-group>
        </div>
        <el-table
          :data="list"
          style="width: 100%"
          :highlight-current-row="true"
          stripe
          tooltip-effect="dark"
          ref="multipleTable"
          v-loading="isLoading"
          header-cell-class-name="table-back"
        >
          <!--  -->
          <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="广告位" prop="name"></el-table-column>
          <el-table-column label="尺寸" prop="size_limit"></el-table-column>
          <el-table-column label="页面" prop="ad_page_name"></el-table-column>
          <el-table-column label="客户端" prop="terminal_name"></el-table-column>
          <el-table-column label="创建时间" prop="updated_at"></el-table-column>
          <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
          <el-table-column>
            <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
            <template slot="header" slot-scope="scope">
              <span style="color: #409EFF">操作</span>
            </template>
            <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
            <template slot-scope="scope">
              <el-button size="mini"  v-permission="'operating.ad.ad-position.list.edit'" @click="openEdit(scope.$index, scope.row,'编辑')">编辑</el-button>
              <el-button
                style="display:none;"
                size="mini"
                v-permission="'operating.ad.ad-position.list.delete'"
                @click="delPosition(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
        <template v-if="list.length > 0">
          <!-- :total="list.length" -->
          <el-pagination
            background
            layout="total,prev, pager, next"
            :current-page="condition.page"
            :total="condition.total"
            :page-size="condition.per_page"
            @current-change="currentChange"
          ></el-pagination>
        </template>
        <add ref="add" :callback="initData" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { parseTime } from "@/utils";
import { getAdPositionList, delPosition ,getPagesList} from "@/service/ad";
import { getTerminals } from "@/service/customer";
import add from "./component/add";
export default {
  name: "List",
  components: {
    add
  },
  data() {
    return {
      list: [],
      condition: {
        name: null,
        terminal_id: "",
        ad_page_id: "",
        page: 1,
        total: null,
        per_page: 10
      },
      terminals: [],
      pages: [],
      isLoading: false
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    getPages(val) {
        this.condition.ad_page_id=null;
      let query = {};

      query["terminal_id"] = val;

      getPagesList(query).then(data => {
        this.pages = data.data;
      });
    },
    delPosition(id) {
      this.$confirm("删除此广告位的同时将影响此广告位上的广告内容展示，请谨慎操作", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delPosition(id)
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.initData();
          })
          .catch(err => {
            this.$message({
              type: "error",
              message: err.message || "删除失败"
            });
          });
      });
    },
    handleAdd(title) {
      this.$refs.add &&
        (this.$refs.add.title = title) &&
        (this.$refs.add.terminals = this.terminals) &&
        this.$refs.add.open();
    },
    async openEdit(index, row, title) {
      let pages=[];
      let query={};
      query["terminal_id"] = row.terminal_id;
      await getPagesList(query).then(data => {
        pages = data.data;
      });
      this.$refs.add &&
        (this.$refs.add.title = title) &&
        (this.$refs.add.pages = pages) &&
        (this.$refs.add.terminals = this.terminals) &&
        (Object.assign(this.$refs.add.locationInfo,row))&& 
        this.$refs.add.open();
    },
    handleSearch() {
      this.condition.page = 1;
      this.initData();
    },
    resetSearch() {
        this.condition={
            name: null,
            terminal_id: "",
            ad_page_id: "",
            page: 1,
            total: null,
            per_page: 10
      }
        this.initData();
    },
    /** 初始化数据请求 */
    async initData() {
      await getTerminals({}).then(data => {
        this.terminals = data;
      });

      // 初始化之前设置当前页面的loading状态
      this.isLoading = true;

      // // 模拟fetch请求数据....
      await getAdPositionList(this.condition).then(data => {
        this.list = [];
        this.condition.total = parseInt(data.total);
        this.condition.per_page = parseInt(data.per_page);
        let listData = data.data;
        listData.forEach(el => {
          el.size_limit = el.width + "*" + el.height;
        });
        this.list = listData;
      });
      // 数据请求完毕取消当前页面的loading
      this.isLoading = false;
    },
    currentChange(index) {
      this.condition.page = index;
      this.initData();
    }
  }
};
</script>

<style scoped>
</style>
